import './lib/supabaseClient';
import React from 'react';
import AppRoutes from './Routes';

function App() {
  return <AppRoutes />;
}

export default App;